/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';

/**
 * PageName: LEISURE_LIST
 */
export const LeisureListPageLog = {
  ListNameButtonQuickFilter: {
    /**
     * LeisureList 퀵필터 노출
     * 이미지 : https://screen.yanolja.in/39vd7pU0L0O7jUXb
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L6}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/quick_filter_item.proto#L0}
     */
    impression({ logMeta, listName }: LeisureListPageLog.ListNameButtonQuickFilter.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 210,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'quickFilter',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * LeisureList 퀵필터 클릭
     * 이미지 : https://screen.yanolja.in/39vd7pU0L0O7jUXb
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L18}
     * ProductListQuickFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L30}
     */
    click({
      selected,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameButtonQuickFilter.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 211,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'quickFilter',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        selected,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonFilter: {
    /**
     * LeisureList 글로벌 필터(리스트필터) 클릭
     * 클릭시 '필터 항목 리스트' 화면이 보임
     *이미지 : https://screen.yanolja.in/hvQcmEua3jT6fhKN
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L31}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta, listName }: LeisureListPageLog.ListNameButtonFilter.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 212,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'filterList',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ListNameButtonSetSort: {
    /**
     * LeisureList 숙소 목록 내 '정렬' 노출
     * 이미지 : https://screen.yanolja.in/vJvwykcaVkLuzCzS
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L44}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    impression({ logMeta, listName }: LeisureListPageLog.ListNameButtonSetSort.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 213,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'setSort',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * LeisureList 숙소 목록 내 '정렬' 클릭
     * 이미지 : https://screen.yanolja.in/vJvwykcaVkLuzCzS
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L56}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta, listName }: LeisureListPageLog.ListNameButtonSetSort.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 214,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'setSort',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ListNameButtonSetSortComplete: {
    /**
     * LeisureList 퀵필터 중 '정렬' 변경 적용
     * 정렬의 경우 적용 버튼이 따로 존재함 - 이미지 : https://screen.yanolja.in/TDR18l29hwVc1GZN
     *######## 아래 events 들은 모두 < LeisureList 필터 리스트 >  ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L68}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta, listName }: LeisureListPageLog.ListNameButtonSetSortComplete.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 215,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'setSortComplete',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ListNameLabelSection: {
    /**
     * LeisureList 필터 리스트 - 각 영역 노출
     * 이미지 : https://screen.yanolja.in/8Ksu2uwOQg6xVVIe
     *라벨의 노출되는 시점에 남길길 희망
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L83}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameLabelSection.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 216,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'sectionLabelName',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameSliderPriceRange: {
    /**
     * LeisureList 필터 리스트 - 가격 범위 슬라이더 조절
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L96}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameSliderPriceRange.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 217,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'priceRangeSlider',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_SLIDER',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameTextFieldPriceRange: {
    /**
     * LeisureList 필터 리스트 - 가격 범위 커서 활성화
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L109}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameTextFieldPriceRange.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 218,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'priceRangeTextField',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonMoreBtn: {
    /**
     * LeisureList 필터 리스트 - 더보기 클릭
     * 더보기 버튼이 있는 영역
     *지역 유형 - 이미지 : https://screen.yanolja.in/z3j9JFEUqlFz7Fan
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L122}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameButtonMoreBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 219,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'moreBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonResetBtn: {
    /**
     * LeisureList 필터 리스트 - 초기화 버튼 클릭
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L137}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameButtonResetBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 220,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'resetBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonFilterComplete: {
    /**
     * LeisureList 필터 리스트 - 필터 적용 버튼 클릭
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L150}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameButtonFilterComplete.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 221,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'filterListComplete',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonNoResult: {
    /**
     * LeisureList 필터 리스트 - 적용 버튼 noResult 노출
     * 이미지 : https://screen.yanolja.in/HiL1RDTmYlJQaTSl
     *적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     *########  < LeisureList 필터 리스트 >  정의 끝 ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L163}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameButtonNoResult.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 222,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'noResult',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameLeisureTicketNo: {
    /**
     * LeisureList - 상품 노출
     * https://screen.yanolja.in/PMxMpa8LVvQPqTAh
     *규칙상 변수는 안 되지만, 변경하기 어려운 레거시므로 유지
     *규칙상 변수는 안 되지만, 변경하기 어려운 레거시므로 유지
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L180}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      leisureTicketNo,
      listName,
    }: LeisureListPageLog.ListNameLeisureTicketNo.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 223,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: leisureTicketNo,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LEISURE_TICKET_NO',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * LeisureList - 상품 클릭 클릭
     * https://screen.yanolja.in/PMxMpa8LVvQPqTAh
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L193}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      leisureTicketNo,
      listName,
    }: LeisureListPageLog.ListNameLeisureTicketNo.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 224,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: leisureTicketNo,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LEISURE_TICKET_NO',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNameLabelNoAvailableLeisureMsg: {
    /**
     * 검색결과 - NoResult 노출
     * 기존 로그 : 앱로그 3526행
     *해당 로그는 기존 로그와 동일하며 CustomJson 의 필터에 대한 부분만 수정
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L205}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameLabelNoAvailableLeisureMsg.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 225,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'NoAvailableLeisureMsg',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNameButtonBackwardBtn: {
    /**
     * 뒤로가기 버튼 클릭
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L220}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    click({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListNameButtonBackwardBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 385,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'backwardBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  ListNameButtonHomeBtn: {
    /**
     * 홈 버튼 클릭
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L232}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    click({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListNameButtonHomeBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 386,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'homeBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  ListNameButtonCartBtn: {
    /**
     * 장바구니 버튼 클릭
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L244}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    click({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListNameButtonCartBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 387,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'cartBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  ListNameButtonSearchBtn: {
    /**
     * 검색창 버튼 클릭
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L256}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    click({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListNameButtonSearchBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 388,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'searchBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  ListNameButtonCategoryBtn: {
    /**
     * 카테고리 버튼 클릭
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L268}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    click({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListNameButtonCategoryBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 389,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'categoryBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  ListNameTabBtn: {
    /**
     * 탭 버튼 노출
     * https://screen.yanolja.in/voL4y8frUVjZ6rqi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L280}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameTabBtn.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 390,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'tabBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * 탭 버튼 클릭
     * https://screen.yanolja.in/voL4y8frUVjZ6rqi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L293}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameTabBtn.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 391,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'tabBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNameBannerOm: {
    /**
     * OMBanner 노츌
     * https://screen.yanolja.in/PNjIf2au562k798M
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L306}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameBannerOm.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 392,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'OMBanner',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * OMBanner 클릭
     * https://screen.yanolja.in/PNjIf2au562k798M
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L319}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: LeisureListPageLog.ListNameBannerOm.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 393,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'OMBanner',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListName: {
    /**
     * 레저 리스트 진입
     * https://screen.yanolja.in/o5Ygay8PiFMhMbZ5
     *objectConainter = 'general' / 'search' 만 필요
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L332}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    view({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListName.View) {
      return KinesisTracker.view('LEISURE_LIST', {
        clientEventId: 449,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_VIEW',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },

    /**
     * 레저 리스트 진입
     * https://screen.yanolja.in/o5Ygay8PiFMhMbZ5
     *objectConainter = 'general' / 'search' 만 필요
     *########  < 레저 전체 카테고리 리스트 >  정의 시작 ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L341}
     * LeisureListCommon
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/leisure.proto#L22}
     */
    resume({
      keyword,
      leisureCategoryNo,
      leisureCategoryName,
      tabName,
      sortType,
      listName,
    }: LeisureListPageLog.ListName.Resume) {
      return KinesisTracker.resume('LEISURE_LIST', {
        clientEventId: 450,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_RESUME',
        keyword,
        leisureCategoryNo,
        leisureCategoryName,
        tabName,
        sortType,
      });
    },
  },

  RecommendSectionCardWidgetItem: {
    /**
     * 레저 리스트 - 추천 위젯 내 상품 노출
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L416}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    impression({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: LeisureListPageLog.RecommendSectionCardWidgetItem.Impression) {
      return KinesisTracker.impression('LEISURE_LIST', {
        clientEventId: 524,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * 레저 리스트 - 추천 위젯 내 상품 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L428}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    click({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: LeisureListPageLog.RecommendSectionCardWidgetItem.Click) {
      return KinesisTracker.click('LEISURE_LIST', {
        clientEventId: 525,
        pageName: 'PAGE_NAME_LEISURE_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace LeisureListPageLog {
  export namespace ListNameButtonQuickFilter {
    /**
     * 이미지 : https://screen.yanolja.in/39vd7pU0L0O7jUXb
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * 이미지 : https://screen.yanolja.in/39vd7pU0L0O7jUXb
     */
    export interface Click {
      /* 실제 노출 되는 값 : {&#34;selected&#34;: True } / {&#34;selected&#34;:False}*/
      selected?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonFilter {
    /**
     * 클릭시 '필터 항목 리스트' 화면이 보임
     *이미지 : https://screen.yanolja.in/hvQcmEua3jT6fhKN
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetSort {
    /**
     * 이미지 : https://screen.yanolja.in/vJvwykcaVkLuzCzS
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * 이미지 : https://screen.yanolja.in/vJvwykcaVkLuzCzS
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetSortComplete {
    /**
     * 정렬의 경우 적용 버튼이 따로 존재함 - 이미지 : https://screen.yanolja.in/TDR18l29hwVc1GZN
     *######## 아래 events 들은 모두 < LeisureList 필터 리스트 >  ######
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameLabelSection {
    /**
     * 이미지 : https://screen.yanolja.in/8Ksu2uwOQg6xVVIe
     *라벨의 노출되는 시점에 남길길 희망
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameSliderPriceRange {
    /**
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameTextFieldPriceRange {
    /**
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonMoreBtn {
    /**
     * 더보기 버튼이 있는 영역
     *지역 유형 - 이미지 : https://screen.yanolja.in/z3j9JFEUqlFz7Fan
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonResetBtn {
    /**
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonFilterComplete {
    /**
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonNoResult {
    /**
     * 이미지 : https://screen.yanolja.in/HiL1RDTmYlJQaTSl
     *적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     *########  < LeisureList 필터 리스트 >  정의 끝 ######
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameLeisureTicketNo {
    /**
     * https://screen.yanolja.in/PMxMpa8LVvQPqTAh
     *규칙상 변수는 안 되지만, 변경하기 어려운 레거시므로 유지
     *규칙상 변수는 안 되지만, 변경하기 어려운 레거시므로 유지
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      leisureTicketNo: string;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/PMxMpa8LVvQPqTAh
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      leisureTicketNo: string;
      listName: string;
    }
  }
  export namespace ListNameLabelNoAvailableLeisureMsg {
    /**
     * 기존 로그 : 앱로그 3526행
     *해당 로그는 기존 로그와 동일하며 CustomJson 의 필터에 대한 부분만 수정
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonBackwardBtn {
    /**
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonHomeBtn {
    /**
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonCartBtn {
    /**
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonSearchBtn {
    /**
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonCategoryBtn {
    /**
     * https://screen.yanolja.in/Kc7k3XIScdSYQ8ML
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace ListNameTabBtn {
    /**
     * https://screen.yanolja.in/voL4y8frUVjZ6rqi
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/voL4y8frUVjZ6rqi
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameBannerOm {
    /**
     * https://screen.yanolja.in/PNjIf2au562k798M
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/PNjIf2au562k798M
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListName {
    /**
     * https://screen.yanolja.in/o5Ygay8PiFMhMbZ5
     *objectConainter = 'general' / 'search' 만 필요
     */
    export interface View {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/o5Ygay8PiFMhMbZ5
     *objectConainter = 'general' / 'search' 만 필요
     *########  < 레저 전체 카테고리 리스트 >  정의 시작 ######
     */
    export interface Resume {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=general 인 경우 카테고리 정보*/
      leisureCategoryNo?: string;
      /* 지면 카테고리 이름  ex) 테마파크*/
      leisureCategoryName?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 정렬완료시 클릭한 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      listName: string;
    }
  }
  export namespace RecommendSectionCardWidgetItem {
    /**
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     */
    export interface Impression {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}

/**
 * PageName: LEISURE_CATEGORY_LIST
 */
export const LeisureCategoryListPageLog = {
  Unspecified: {
    /**
     * 레저 전체 카테고리 리스트 진입
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L352}
     */
    view({}: LeisureCategoryListPageLog.Unspecified.View = {}) {
      return KinesisTracker.view('LEISURE_CATEGORY_LIST', {
        clientEventId: 451,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        eventType: 'EVENT_TYPE_VIEW',
      });
    },

    /**
     * 레저 전체 카테고리 리스트 진입
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L359}
     */
    resume({}: LeisureCategoryListPageLog.Unspecified.Resume = {}) {
      return KinesisTracker.resume('LEISURE_CATEGORY_LIST', {
        clientEventId: 452,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        eventType: 'EVENT_TYPE_RESUME',
      });
    },
  },

  LeisureCategoryListButtonSeeAllBtn: {
    /**
     * 레저 전체 카테고리 리스트 - `전체 상품 보기'선택
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L366}
     */
    click({}: LeisureCategoryListPageLog.LeisureCategoryListButtonSeeAllBtn.Click = {}) {
      return KinesisTracker.click('LEISURE_CATEGORY_LIST', {
        clientEventId: 453,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        object: 'seeAllBtn',
        objectContainer: 'LeisureCategoryList',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  LeisureCategoryListButtonDepth1: {
    /**
     * 중분류 카테고리(depth1) 선택
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L377}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/list/leisure_category.proto#L0}
     */
    click({ logMeta }: LeisureCategoryListPageLog.LeisureCategoryListButtonDepth1.Click) {
      return KinesisTracker.click('LEISURE_CATEGORY_LIST', {
        clientEventId: 454,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        object: 'depth1',
        objectContainer: 'LeisureCategoryList',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  LeisureCategoryListButtonDepth2: {
    /**
     * 소분류 카테고리(depth2) 선택
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L389}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/list/leisure_category.proto#L0}
     */
    click({ logMeta }: LeisureCategoryListPageLog.LeisureCategoryListButtonDepth2.Click) {
      return KinesisTracker.click('LEISURE_CATEGORY_LIST', {
        clientEventId: 455,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        object: 'depth2',
        objectContainer: 'LeisureCategoryList',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  LeisureCategoryListButtonCloseBtn: {
    /**
     * 닫기 버튼
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *########  < 레저 전체 카테고리 리스트 >  정의 끝 ######
     *########  < 레저 recommendSection 위젯 >  정의 시작 #########
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/leisure/web.txtpb#L401}
     */
    click({}: LeisureCategoryListPageLog.LeisureCategoryListButtonCloseBtn.Click = {}) {
      return KinesisTracker.click('LEISURE_CATEGORY_LIST', {
        clientEventId: 456,
        pageName: 'PAGE_NAME_LEISURE_CATEGORY_LIST',
        object: 'closeBtn',
        objectContainer: 'LeisureCategoryList',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace LeisureCategoryListPageLog {
  export namespace Unspecified {
    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     */
    export interface View {}

    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     */
    export interface Resume {}
  }
  export namespace LeisureCategoryListButtonSeeAllBtn {
    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     */
    export interface Click {}
  }
  export namespace LeisureCategoryListButtonDepth1 {
    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace LeisureCategoryListButtonDepth2 {
    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace LeisureCategoryListButtonCloseBtn {
    /**
     * https://screen.yanolja.in/V9QJvGV9lx9wTLIi
     *########  < 레저 전체 카테고리 리스트 >  정의 끝 ######
     *########  < 레저 recommendSection 위젯 >  정의 시작 #########
     */
    export interface Click {}
  }
}
